import React, { Component } from 'react';

export default class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageStatus: false
    };
    this.style1 = {
      opacity: 0
    };
    this.style2 = {
      opacity: 1
    };
  }

  handleImageLoaded() {
    this.setState({ imageStatus: true });
  }

  handleImageErrored() {
    this.setState({ imageStatus: false });
  }

  render() {
    return (
      <div className={'image-wrapper'}>
        <img
          style={this.state.imageStatus ? this.style2 : this.style1}
          src={this.props.source}
          onLoad={this.handleImageLoaded.bind(this)}
          onError={this.handleImageErrored.bind(this)}
        />
        <style jsx>{`
          .image-wrapper {
            width: 100%;
            height: auto;
          }
          img {
            width: 100%;
            height: auto;
            margin-bottom: -4px;
            transition: opacity 1000ms ease;
          }
        `}</style>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/dom-elements/Image.js